export default __webpack_public_path__ + "static/plexus-full-width-4-fd6ffdc38995b4cf7ae4d7b3aecb24e8.avif";